import { BookOpen } from "lucide-react";

export function Logo({ variant = "dark", size = "md" }) {
  const sizes = { sm: "h-8", md: "h-10", lg: "h-12" };
  const textSizes = { sm: "text-lg", md: "text-xl", lg: "text-2xl" };
  const isLight = variant === "light";
  const gradient = "linear-gradient(135deg, #1F3A8A 0%, #8B5CF6 100%)";
  return (
    <div className="flex items-center gap-2.5" data-testid="brand-logo">
      <div className={`${sizes[size]} aspect-square rounded-xl flex items-center justify-center shadow-md`}
           style={{ background: gradient }}>
        <BookOpen className="text-white" strokeWidth={2.4} size={size === "sm" ? 18 : 22} />
      </div>
      <div className="leading-none">
        <div className={`font-heading font-extrabold ${textSizes[size]} ${isLight ? "text-white" : "text-[#1F3A8A]"}`}>
          AulaPronta
        </div>
        {size !== "sm" && (
          <div className={`text-[10px] uppercase tracking-[0.25em] font-semibold mt-1 ${isLight ? "text-white/70" : "text-slate-500"}`}>
            IA para Professores
          </div>
        )}
      </div>
    </div>
  );
}
